import React from 'react'
import Grid from '@material-ui/core/Grid'
import makeStyles from '@material-ui/core/styles/makeStyles'
import ReCAPTCHA from 'react-google-recaptcha'

import { constants, recaptcha } from '../utils'
import portalConfig from '../services/portalConfig'

const useStyles = makeStyles(() => ({
  recaptchaContainer: {
    width: '100%',
    marginTop: '24px',
    display: 'flex',
    justifyContent: 'center',
  },
}))

// A chave pública vem da configuração global do console; a embutida fica de reserva
// para console que ainda não a informa.
const siteKey = () => {
  const config = portalConfig.config()

  return (config && config.recaptchaSiteKey) || constants.params.recaptcha
}

const Recaptcha = ({ onChange }) => {
  const classes = useStyles()

  React.useEffect(() => {
    if (!recaptcha.isEnabled()) onChange('recaptcha-disabled')
  }, [onChange])

  if (!recaptcha.isEnabled()) return null

  const tryToValidate = async token => {
    const result = await recaptcha.isValid(token)

    if (result.status === 200) {
      onChange("It's a valid token bro!")
    } else {
      console.error(result)
    }
  }

  return (
    <Grid item className={classes.recaptchaContainer}>
      <ReCAPTCHA onChange={tryToValidate} sitekey={siteKey()} />
    </Grid>
  )
}

export default Recaptcha
